import { render } from "./Subject.vue?vue&type=template&id=170a6db6&scoped=true"
import script from "./Subject.vue?vue&type=script&lang=js"
export * from "./Subject.vue?vue&type=script&lang=js"

import "./Subject.vue?vue&type=style&index=0&id=170a6db6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-170a6db6"

export default script